import { Typography, Space, Breadcrumb } from 'antd';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { AdminBreadcrumbItem } from '../utils/adminBreadcrumbs';

const { Title, Text } = Typography;

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Total rows currently shown (e.g. table result count) */
  resultCount?: number;
  extra?: ReactNode;
  /** When provided (including empty array), controls breadcrumb row */
  breadcrumbs?: AdminBreadcrumbItem[];
}

export function PageHeader({
  title,
  subtitle,
  resultCount,
  extra,
  breadcrumbs,
}: PageHeaderProps) {
  const { t } = useTranslation();
  const hasMeta = subtitle || resultCount !== undefined;
  const showCrumbs = breadcrumbs && breadcrumbs.length > 0;

  return (
    <div className="admin-page-header">
      <div className="admin-page-header__main">
        {showCrumbs ? (
          <Breadcrumb
            className="admin-page-header__breadcrumb"
            items={breadcrumbs}
            separator="/"
          />
        ) : null}
        <Title level={3} className="admin-page-header__title">
          {title}
        </Title>
        {hasMeta ? (
          <div className="admin-page-header__meta">
            {subtitle ? (
              <Text type="secondary" className="admin-page-header__subtitle">
                {subtitle}
              </Text>
            ) : null}
            {resultCount !== undefined ? (
              <Text type="secondary" className="admin-page-header__count">
                {t(resultCount === 1 ? 'common.record_one' : 'common.record_other', {
                  count: resultCount,
                })}
              </Text>
            ) : null}
          </div>
        ) : null}
      </div>
      {extra ? <Space wrap className="admin-page-header__extra">{extra}</Space> : null}
    </div>
  );
}

export default PageHeader;
